import { QUERY_KEY_PREFIXES } from 'dpl/shared/fetching/utils/constants';

export function paymentRequestsQueryDefinition(breederProfileId, incomplete = false, limit) {
  return {
    params: { incomplete, limit },
    prefix: QUERY_KEY_PREFIXES.BREEDER_APP_PAYMENTS,
    url: `/api/breeder_app/breeder_profiles/${breederProfileId}/payment_requests.json`
  };
}

export function paymentSourcesQueryDefinition() {
  return {
    url: '/api/options/payment_sources.json'
  };
}

export function breederAppCreatePaymentRequestMutationDefinition(breederProfileId) {
  return {
    url: `/api/breeder_app/breeder_profiles/${breederProfileId}/payment_requests.json`,
    method: 'POST'
  };
}

export function breederAppPaymentSummaryQueryDefinition(breederProfileId) {
  return {
    url: `/api/breeder_app/breeder_profiles/${breederProfileId}/payment_summary.json`,
    prefix: QUERY_KEY_PREFIXES.BREEDER_APP_PAYMENT_SUMMARY,
    defaultValue: {
      data: {
        monthly_balance: '0',
        pending_balance: '0',
        total_balance: '0'
      }
    }
  };
}

export function breederAppPaymentSettingsShowQueryDefinition(breederProfileId) {
  return {
    url: `/api/breeder_app/breeder_profiles/${breederProfileId}/payment_settings.json`,
    prefix: QUERY_KEY_PREFIXES.BREEDER_APP_PAYMENT_SETTINGS,
    defaultValue: {
      data: {}
    }
  };
}

export function breederAppEditPaymentRequestMutationDefinition(
  breederProfileId,
  paymentRequestId) {
  return {
    url: `/api/breeder_app/breeder_profiles/${breederProfileId}/payment_requests/${paymentRequestId}.json`,
    method: 'PATCH'
  };
}
